import {
  CroppingSuitabilityReportModel,
  LandSuitabilityClassesType,
} from "@agroyaar/sdk";

export function generateLandSuitabilityClassParagraphs(
  croppingSuitabilityReports: CroppingSuitabilityReportModel[]
) : string[]{
  const grouped: Record<LandSuitabilityClassesType, string[]> = {
    S1: [],
    S2: [],
    S3: [],
    N: [],
  };

  croppingSuitabilityReports.forEach((report) => {
    grouped[report.landSuitabilityClass.name].push(report.crop.persianName);
  });

  const paragraphs: string[] = [];

  if (grouped.S1.length > 0) {
    paragraphs.push(
      `زمین مورد نظر برای محصول ${grouped.S1.join(
        "، "
      )} خیلی مناسب (S1) ارزیابی شده است. به این معنی که شرایط زمین کاملاً با نیازهای محصول سازگار است و محدودیت‌ها ناچیز هستند. عملکرد بالا قابل دستیابی است.`
    );
  }

  if (grouped.S2.length > 0) {
    paragraphs.push(
      `زمین مورد نظر برای محصول ${grouped.S2.join(
        "، "
      )} نسبتاً مناسب (S2) ارزیابی می‌شود. به این معنی که زمین دارای برخی محدودیت‌های متوسط است که ممکن است عملکرد محصول را نسبت به شرایط ایده‌آل کاهش دهد.`
    );
  }

  if (grouped.S3.length > 0) {
    paragraphs.push(
      `زمین مورد نظر برای محصول ${grouped.S3.join(
        "، "
      )} نسبتاً نامناسب (S3) ارزیابی شده است. به این معنی که زمین دارای محدودیت‌های قابل توجه است که منجر به کاهش محسوس عملکرد می‌شود. استفاده از زمین برای این محصولات با ریسک همراه است و صرفه اقتصادی پایین‌تری دارد.`
    );
  }

  if (grouped.N.length > 0) {
    paragraphs.push(
      `زمین مورد نظر برای محصول ${grouped.N.join(
        "، "
      )} نامناسب (N) ارزیابی می‌شود. به این معنی که زمین برای کاشت محصول مورد نظر مناسب نیست یا محدودیت‌های شدیدی دارد که مانع تولید اقتصادی می‌شود.`
    );
  }

  return paragraphs;
}
